import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { InitialDataRepository } from '../../../domain/repositories/initial-data/initial-data.repository';
import {
  Breed,
  CatalogResponse,
  CirculationZone,
  Country,
  PetQuestion,
} from '../../../domain/interfaces/initial-data/initial-data.interface';
import { InitialDataService } from '../../services/initial-data/initial-data.service';

/**
 * Implementación del repositorio de datos iniciales
 * Usa el InitialDataService para obtener los datos del API
 */
@Injectable({
  providedIn: 'root',
})
export class InitialDataRepositoryImplementation extends InitialDataRepository {
  private readonly initialDataService = inject(InitialDataService);

  /**
   * Obtiene todos los datos del catálogo inicial
   */
  getAllInitialData(): Observable<CatalogResponse> {
    return this.initialDataService.getAllInitialData();
  }

  /**
   * Obtiene la lista de países
   */
  getCountries(): Observable<Country[]> {
    return this.initialDataService.getCountries();
  }

  /**
   * Obtiene las zonas de circulación
   */
  getCirculationZones(): Observable<CirculationZone[]> {
    return this.initialDataService.getCirculationZones();
  }

  /**
   * Obtiene las razas de mascotas
   */
  getBreeds(): Observable<Breed[]> {
    return this.initialDataService.getBreeds();
  }

  /**
   * Obtiene las preguntas para mascotas
   */
  getPetQuestions(): Observable<PetQuestion[]> {
    return this.initialDataService.getPetQuestions();
  }
}
